import React from "react";

import { Popconfirm } from "antd";

import {
  FolderAddOutlined,
  DeleteOutlined,
  EditOutlined,
} from "@ant-design/icons";

import "./index.scss";

const ContextMenu = React.memo((props: any) => {
  const { onCreateDir, onConfirmDel, onCancelDel, onRenameDir, node } = props;
  return (
    <div className="context-menu-container">
      <div className="context-menu-icon new" onClick={() => onCreateDir(node)}>
        <FolderAddOutlined style={{ fontSize: 20 }} />
      </div>
      <div className="context-menu-icon del">
        <Popconfirm
          placement="right"
          title={"是否删除?"}
          onConfirm={() => {
            onConfirmDel(node);
          }}
          onCancel={() => onCancelDel()}
          okText="确认"
          cancelText="取消"
        >
          <DeleteOutlined style={{ fontSize: 20 }} />
        </Popconfirm>
      </div>
      <div
        className="context-menu-icon rename"
        onClick={() => onRenameDir(node)}
      >
        <EditOutlined style={{ fontSize: 20 }} />
      </div>
    </div>
  );
});

export default ContextMenu;
